"use client";
import { cn } from "@/src/shared/utils/mergeTwClasses";
import Link from "next/link";
import {FC, useEffect, useRef, useState} from "react";
import { Button } from "../../Button";
import WebshopIcon from "../../WebShopIcon/components/WebShopIcon";
import {HeaderActionProps, ViberActionProps} from "../lib/type";
import { IconButton, Modal, Stack, Typography } from "@mui/material";
import WebShopIcon from "../../WebShopIcon/components/WebShopIcon";
import { QRCode } from "../../QRCode";
import {useAnalytics} from "@/src/components/pages/StepPage/components/useAnalytics";

export const ViberAction: FC<ViberActionProps> = ({
  name,
  variant,
  icon,
  href = "/",
  analytics,
}) => {
  const { callAnalyticEvent } = useAnalytics();
  const [isOpen, setIsOpen] = useState(false);
  const timerRef = useRef<NodeJS.Timeout>();
  const openModal = () => {
    setIsOpen(true);
  };

  const handleAnalytic = () => {
    analytics && callAnalyticEvent(analytics);
  }

  const handleVisibilityChange = () => {
    if (document.hidden || document.visibilityState === 'visible') {
      // Clear timeout if tab is visible
      clearTimeout(timerRef.current);
    }
  };

  const handleWindowBlur = () => {
    // Clear timeout if window is blurred
    clearTimeout(timerRef.current);
  };

  useEffect(() => {
    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener("blur", handleWindowBlur);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
      window.removeEventListener("blur", handleWindowBlur);
    };
  }, []);

  const openViber = () => {
    handleAnalytic();
    window.location.href = href;
    // Set timeout to open modal after 2 seconds
    timerRef.current = setTimeout(() => {
      if (!document.hidden || document.visibilityState !== 'visible') {
        setIsOpen(true);
      }
    }, 2000);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  return (
    <>
      <Button
        variant={variant}
        className={"min-w-[132px] border-purple text-purple max-md:hidden"}
        startIcon={<WebshopIcon name={icon.name} width={16} height={16} />}
        size={"small"}
        // href={href}
        onClick={openViber}
      >
        {name}
      </Button>

      <Link className={cn("hidden max-md:flex")} href={href} type={undefined} aria-label={name + " viber"} onClick={handleAnalytic}>
        <WebshopIcon
          name={icon.name}
          fill={icon.color ?? undefined}
          width={26}
          height={26}
        />
      </Link>

      <Modal
        open={isOpen}
        onClose={closeModal}
        className={"max-md:z-opened-nav-drawer"}
      >
        <Stack
          className={
            "darkErrorMessage mx-auto my-0 flex w-full max-w-[524px] flex-col gap-6 rounded-xl bg-white p-6 center-modal max-md:static max-md:h-full max-md:w-full max-md:max-w-none max-md:translate-x-0 max-md:translate-y-0 max-md:animate-up-modal max-md:overflow-y-auto max-md:rounded-none max-md:pt-24 md:max-h-[95%]"
          }
        >
          <Stack className={"flex w-full flex-row items-start gap-3"}>
            <Typography
              variant={"h1"}
              component={"h3"}
              className={
                "flex-1 justify-center text-center text-2xl font-semibold max-md:justify-start max-md:text-start"
              }
            >
              {"Онлайн допомога"}
            </Typography>

            <IconButton onClick={closeModal} className={"max-md:hidden"}>
              <WebShopIcon name={"close"} className="fill-blue" />
            </IconButton>
          </Stack>
          <div className="flex flex-col items-center justify-center gap-2">
            <Typography className={"text-[15px] text-dark-gray"}>
              {
                "Відскануйте QR-код та розпочніть діалог з нашим оператором в VIber"
              }
            </Typography>
            <QRCode className={"p-4"} value={href} size={248} />
          </div>
        </Stack>
      </Modal>
    </>
  );
};
